const press = {
  init() {
    this.togglePressRoom();
  },

  togglePressRoom () {
    $('.press-tab-hha a').on('click', function() {
      $('.sidebar-content').removeClass('press-sidebar-hhw').addClass('press-sidebar-hha');
    });

    $('.press-tab-hhw a').on('click', function() {
      $('.sidebar-content').removeClass('press-sidebar-hha').addClass('press-sidebar-hhw');
    });
  }

};

press.init();
